import(/* webpackMode: "eager" */ "/codebuild/output/src3742464591/src/apps/jumplab/src/app/error.tsx");
